import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Select} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {getStatusOptions} from '../../utils';

class StatusPart extends Component {
  componentDidMount() {
    this.props.fetchWarrantyErrorCodesList();
  }

  parseErrorCodes = () => {
    const {errorCodes} = this.props;
    return errorCodes.filter((error) => error.status === 'A').map((error, index) => {
      return {
        'key': index,
        'text': `${error.code}-${error.description}`,
        'value': error.code,
      };
    });
  };

  render() {
    const {warrantyStatus, handleChange, stateTwc, errorId} = this.props;
    const statusOptions = getStatusOptions(warrantyStatus, 'status');
    const errorCodeOptions = this.parseErrorCodes();
    const hasError = stateTwc === '08' || stateTwc === '10' || stateTwc === '03';
    return (
      <>
        <Form.Field
          value={stateTwc}
          control={Select}
          options={statusOptions}
          label='Estado TWC'
          placeholder='Status - Description'
          onChange={(e, {value}) => handleChange('stateTwc', value)}
        />
        <Form.Field
          value={errorId}
          control={Select}
          options={errorCodeOptions}
          label='Código Error'
          placeholder='Código - Description'
          onChange={(e, {value}) => handleChange('errorId', value)}
          clearable
          disabled = {!hasError}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'warrantyStatus': state.warrantyAdmin.warrantyStatus,
    'errorCodes': state.warrantyErrorCodes.list,
    'loading': state.warrantyErrorCodes.loading,
  };
};

const {fetchWarrantyErrorCodesList} = Actions;

export default connect(mapStateToProps, {
  fetchWarrantyErrorCodesList,
})(StatusPart);
